import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Label from "./LabelF";
import axios from "axios";

import cancel from "../../../../../assets/images/icons/cancel_white.png";

import PropTypes from "prop-types";

import useMediaQuery from "@mui/material/useMediaQuery";
import ListSubheader from "@mui/material/ListSubheader";

import { useTheme } from "@mui/material/styles";
import { VariableSizeList } from "react-window";
import Typography from "@mui/material/Typography";

import { farmageo_api } from "../../../../../config";

const LISTBOX_PADDING = 8; // px

function renderRow(props) {
  const { data, index, style } = props;
  const dataSet = data[index];
  const inlineStyle = {
    ...style,
    top: style.top + LISTBOX_PADDING,
    fontSize: "0.80rem",
  };

  if (dataSet.hasOwnProperty("group")) {
    return (
      <ListSubheader key={dataSet.key} component="div" style={inlineStyle}>
        {dataSet.group}
      </ListSubheader>
    );
  }

  return (
    <Typography component="li" {...dataSet[0]} noWrap style={inlineStyle}>
      {dataSet[1]}
    </Typography>
  );
}

const OuterElementContext = React.createContext({});

const OuterElementType = React.forwardRef((props, ref) => {
  const outerProps = React.useContext(OuterElementContext);
  return <div ref={ref} {...props} {...outerProps} />;
});

function useResetCache(data) {
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (ref.current != null) {
      ref.current.resetAfterIndex(0, true);
    }
  }, [data]);
  return ref;
}

// Adapter for react-window
const ListboxComponent = React.forwardRef(function ListboxComponent(
  props,
  ref
) {
  const { children, ...other } = props;
  const itemData = [];
  children.forEach((item) => {
    itemData.push(item);
    itemData.push(...(item.children || []));
  });

  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"), {
    noSsr: true,
  });

  const itemCount = itemData.length;
  const itemSize = smUp ? 36 : 48;

  const getChildSize = (child) => {
    if (child.hasOwnProperty("group")) {
      return 48;
    }

    return itemSize;
  };

  const getHeight = () => {
    if (itemCount > 8) {
      return 8 * itemSize;
    }
    return itemData.map(getChildSize).reduce((a, b) => a + b, 0);
  };

  const gridRef = useResetCache(itemCount);

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={other}>
        <VariableSizeList
          itemData={itemData}
          height={getHeight() + 2 * LISTBOX_PADDING}
          width="100%"
          ref={gridRef}
          outerElementType={OuterElementType}
          innerElementType="ul"
          itemSize={(index) => getChildSize(itemData[index])}
          overscanCount={5}
          itemCount={itemCount}
        >
          {renderRow}
        </VariableSizeList>
      </OuterElementContext.Provider>
    </div>
  );
});

ListboxComponent.propTypes = {
  children: PropTypes.node,
};

export default function Virtualize(cab) {
  const {
    id_elemento,
    id_a,
    className,
    setFiltrosAAplicar,
    clave_envio,
    autocompletar_minimo = 3,
  } = cab;
  //const { superSubmit } = useContext(FuncionesContext);

  //const { Dispatch } = useContext(context);

  const [value, setValue] = useState("");
  const [inputValue, setInputValue] = useState("");

  //const [v, setV] = useState();

  const [opciones, setOpciones] = useState([]);
  const [fetchTimeout, setFetchTimeout] = useState();

  const handleCancelar = () => {
    setFiltrosAAplicar((prevState) => {
      return {
        ...prevState,
        [id_a]: undefined,
        ...(clave_envio ? { [clave_envio]: undefined } : {}), // Agrega clave_envio solo si existe
      };
    });
    setValue(undefined);
  };

  const handleChangeValue = async (newValue) => {
    const valor = newValue.value; //newValue { value, label }

    setFiltrosAAplicar((prevState) => {
      return {
        ...prevState,
        [id_a]: valor,
        ...(clave_envio ? { [clave_envio]: valor } : {}), // Agrega clave_envio solo si existe
      };
    });
    setValue(newValue.label);
  };

  const onInputChange = async (event, newInputValue) => {
    clearTimeout(fetchTimeout); // Utiliza el identificador del temporizador

    if (newInputValue.length > autocompletar_minimo) {
      const newTimeout = setTimeout(() => {
        axios
          .post(farmageo_api + "/autocompletar/opciones/" + id_a, {
            value: newInputValue,
          })
          .then((res) => {
            setOpciones(() =>
              res.data.sort((a, b) =>
                a.label.toUpperCase().localeCompare(b.label.toUpperCase())
              )
            );
          });
      }, 800);
      setFetchTimeout(newTimeout);
    }
    setInputValue(newInputValue);
  };

  //   useEffect(() => {
  //     if (v) {
  //       axios
  //         .post(farmageo_api + "/autocompletar/opciones/" + id_a, {
  //           value: v,
  //         })
  //         .then((res) => {
  //           setOpciones(() => res.data);
  //           setValue(res.data[0].label);
  //         });
  //     }
  //   }, [id_a, v]);

  return (
    <>
      <div className="vista_label">
        {cab.nombre ? (
          <Label
            label={cab.nombre}
            opcionales_null={cab.opcionales_null}
            permite_null={cab.permite_null}
          />
        ) : (
          <></>
        )}
      </div>
      <Autocomplete
        value={value}
        id={id_elemento}
        sx={{ width: "100%" }}
        disableListWrap
        disableClearable
        size="small"
        className={` ${className}`}
        filterOptions={(x) => x}
        ListboxComponent={ListboxComponent}
        options={opciones}
        groupBy={(option) => {
          return option.label[0].toUpperCase();
        }}
        renderInput={(params) => (
          <div style={{ position: "relative" }}>
            <TextField
              {...params}
              label={cab.placeholder}
              className={` _autoComplete`}
            />
            <img
              onClick={() => handleCancelar()}
              src={cancel}
              style={{
                position: "absolute",
                top: "12px",
                right: "16px",
                cursor: "pointer",
                
              }}
              className="columna_input_date_null"
              width="15px"
              alt="cancelar"
            />
          </div>
        )}
        renderOption={(props, option) => [props, option.label]}
        // TODO: Post React 18 update - validate this conversion, look like a hidden bug
        renderGroup={(params) => params}
        onChange={(event, newValue) => handleChangeValue(newValue)}
        inputValue={inputValue}
        onInputChange={onInputChange}
        getOptionLabel={(option) => {
          return option.label ?? option;
        }}
      />{" "}
    </>
  );
}
